import useDayJs from '@plugins/useDayJs';

export function utcToUserTimezone(utc) {
    const dayjs = useDayJs();
    const userStore = useUserStore();

    return dayjs(utc).tz(userStore.getTimezone).format();
}
